import React, { useEffect, useState } from 'react';
import { AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getUserInfo } from '../services/api';
import '../styles/RoundRobinRankings.css';

const RoundRobinRankings = ({ userInfo: propUserInfo }) => {
  const [userInfo, setUserInfo] = useState(propUserInfo || null);
  const [isLoading, setIsLoading] = useState(!propUserInfo);
  const [error, setError] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (propUserInfo) {
      setUserInfo(propUserInfo);
      setIsLoading(false);
      return;
    }

    const fetchUserInfo = async () => {
      try {
        const data = await getUserInfo();
        setUserInfo(data);
        setIsLoading(false);
      } catch (error) {
        console.error('Failed to fetch user info:', error);
        setError('ユーザー情報の取得に失敗しました');
        setIsLoading(false);
      }
    };

    fetchUserInfo();
  }, [propUserInfo]);

  if (isLoading) {
    return (
      <div className="round-robin-rankings page">
        <div className="round-robin-rankings container">
          <div className="round-robin-rankings card">
            <div className="round-robin-rankings state">
              <div className="round-robin-rankings spinner" aria-hidden="true" />
              <p>データを読み込んでいます...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="round-robin-rankings page">
        <div className="round-robin-rankings container">
          <div className="round-robin-rankings card">
            <div className="round-robin-rankings state" role="alert">
              <AlertCircle size={40} />
              <p>{error}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!userInfo) {
    return (
      <div className="round-robin-rankings page">
        <div className="round-robin-rankings container">
          <div className="round-robin-rankings card">
            <div className="round-robin-rankings state" role="alert">
              <AlertCircle size={40} />
              <p>ユーザー情報が見つかりません</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const rankings = userInfo.round_robin_rankings || [];

  return (
    <div className="round-robin-rankings page">
      <div className="round-robin-rankings container">
        <header className="round-robin-rankings page-header">
          <div>
            <h1 className="round-robin-rankings title">ラウンドロビン順位</h1>
            <p className="round-robin-rankings subtitle">あなたの希望順位を一覧で確認できます。</p>
          </div>
          <Link to="/dashboard" className="round-robin-rankings header-link">
            ダッシュボードへ
          </Link>
        </header>

        <section className="round-robin-rankings card">
          <div className="round-robin-rankings card-header">
            <h2 className="round-robin-rankings card-title">順位一覧</h2>
          </div>
          <div className="round-robin-rankings card-body">
            {windowWidth > 768 ? (
              <div className="round-robin-rankings table-wrap">
                <table className="round-robin-rankings table">
                  <thead className="round-robin-rankings table-head">
                    <tr className="round-robin-rankings table-head-row">
                      <th className="round-robin-rankings table-head-cell">対象</th>
                      <th className="round-robin-rankings table-head-cell">順位</th>
                    </tr>
                  </thead>
                  <tbody className="round-robin-rankings table-body">
                    {rankings.map((rank, index) => (
                      <tr key={index} className="round-robin-rankings table-row">
                        <td className="round-robin-rankings table-cell">第{index + 1}クール</td>
                        <td className="round-robin-rankings table-cell">
                          <span className="round-robin-rankings rank">{rank}位</span>
                        </td>
                      </tr>
                    ))}
                    <tr className="round-robin-rankings table-row">
                      <td className="round-robin-rankings table-cell">地域医療</td>
                      <td className="round-robin-rankings table-cell">
                        <span className="round-robin-rankings rank">{userInfo.rural_ranking}位</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="round-robin-rankings cards">
                {rankings.map((rank, index) => (
                  <div key={index} className="round-robin-rankings card-item">
                    <span className="round-robin-rankings card-label">第{index + 1}クール</span>
                    <span className="round-robin-rankings rank">{rank}位</span>
                  </div>
                ))}
                <div className="round-robin-rankings card-item">
                  <span className="round-robin-rankings card-label">地域医療</span>
                  <span className="round-robin-rankings rank">{userInfo.rural_ranking}位</span>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default RoundRobinRankings;
